const englishCountries = [
  // 향후 무국적(neutral) 항목 추가 가능
  { name: 'United States', flagCode: 'us', abbr: 'US' },
  { name: 'United Kingdom', flagCode: 'gb', abbr: 'UK' },
  { name: 'Australia', flagCode: 'au', abbr: 'AU' },
  { name: 'Canada', flagCode: 'ca', abbr: 'CA' },
  { name: 'Singapore', flagCode: 'sg', abbr: 'SG' },
  { name: 'India', flagCode: 'in', abbr: 'IN' }
];

const spanishCountries = [
  // 향후 무국적(neutral) 항목 추가 가능
  { name: 'Spain', flagCode: 'es', abbr: 'ES' },
  { name: 'Mexico', flagCode: 'mx', abbr: 'MX' },
  { name: 'Argentina', flagCode: 'ar', abbr: 'AR' },
  { name: 'Colombia', flagCode: 'co', abbr: 'CO' },
  { name: 'Chile', flagCode: 'cl', abbr: 'CL' },
  { name: 'Peru', flagCode: 'pe', abbr: 'PE' }
];

const portugueseCountries = [
  // 향후 무국적(neutral) 항목 추가 가능
  { name: 'Portugal', flagCode: 'pt', abbr: 'PT' },
  { name: 'Brazil', flagCode: 'br', abbr: 'BR' }
];

export const LANGUAGES = [
  // 영어권 6개 (번역 id 모두 'en')
  { name: 'English (United States)', flagCode: 'us', id: 'en', countries: englishCountries, displayName: 'English (USA)' },
  { name: 'English (United Kingdom)', flagCode: 'gb', id: 'en', countries: englishCountries, displayName: 'English (UK)' },
  { name: 'English (Australia)', flagCode: 'au', id: 'en', countries: englishCountries, displayName: 'English (AU)' },
  { name: 'English (Canada)', flagCode: 'ca', id: 'en', countries: englishCountries, displayName: 'English (CA)' },
  { name: 'English (Singapore)', flagCode: 'sg', id: 'en', countries: englishCountries, displayName: 'English (SG)' },
  { name: 'English (India)', flagCode: 'in', id: 'en', countries: englishCountries, displayName: 'English (IN)' },

  { name: 'Korean', flagCode: 'kr', id: 'ko' },
  { name: 'Vietnamese', flagCode: 'vn', id: 'vi' },
  { name: 'Japanese', flagCode: 'jp', id: 'ja' },

  { name: 'Chinese (Mainland)', flagCode: 'cn', id: 'zh-cn', displayName: 'Chinese (China)' },
  { name: 'Chinese (Taiwan)', flagCode: 'tw', id: 'zh-tw' },

  { name: 'Russian', flagCode: 'ru', id: 'ru' },
  { name: 'Thai', flagCode: 'th', id: 'th' },
  { name: 'Indonesian', flagCode: 'id', id: 'id' },

  // 스페인어권 6개 (번역 id 모두 'es')
  { name: 'Spanish (Spain)', flagCode: 'es', id: 'es', countries: spanishCountries, displayName: 'Spanish (ES)' },
  { name: 'Spanish (Mexico)', flagCode: 'mx', id: 'es', countries: spanishCountries, displayName: 'Spanish (MX)' },
  { name: 'Spanish (Argentina)', flagCode: 'ar', id: 'es', countries: spanishCountries, displayName: 'Spanish (AR)' },
  { name: 'Spanish (Chile)', flagCode: 'cl', id: 'es', countries: spanishCountries, displayName: 'Spanish (CL)' },
  { name: 'Spanish (Colombia)', flagCode: 'co', id: 'es', countries: spanishCountries, displayName: 'Spanish (CO)' },
  { name: 'Spanish (Peru)', flagCode: 'pe', id: 'es', countries: spanishCountries, displayName: 'Spanish (PE)' },

  { name: 'French', flagCode: 'fr', id: 'fr' },
  { name: 'German', flagCode: 'de', id: 'de' },

  // 포르투갈어 2개 (번역 id 모두 'pt')
  { name: 'Portuguese (Portugal)', flagCode: 'pt', id: 'pt', countries: portugueseCountries, displayName: 'Portuguese (PT)' },
  { name: 'Portuguese (Brazil)', flagCode: 'br', id: 'pt', countries: portugueseCountries, displayName: 'Portuguese (BR)' }
];
export const STATELESS = { name: '무국적 (Stateless)', flagCode: 'xx', displayName: 'Stateless' };

export const resolveLanguageId = (val) => {
  if (!val) return null;
  let match = LANGUAGES.find(l => l.id === val);
  if (!match) match = LANGUAGES.find(l => l.name === val);
  if (!match) match = LANGUAGES.find(l => (l.countries ? l.name.split(' (')[0] : l.name) === val);
  return match ? match.id : null;
};
